export default __webpack_public_path__ + "../img/43ad83544e84779b511d23cc3754c53f.png";